import type {
  AuthzOrganisation,
  AuthzWorkspace,
} from "connect-api/authz/schemas/authz-context";

const FALLBACK_LOGO_URL = "/spirii-icon.svg";

interface WorkspaceOption {
  value: string;
  label: string;
  imageUrl: string;
}

function getWorkspaceLogoUrl(workspace: AuthzWorkspace): string {
  const operatorWithLogo = workspace.domain?.cpms?.operators.find(
    (operator) => operator.logoUrl
  );
  return operatorWithLogo?.logoUrl ?? FALLBACK_LOGO_URL;
}

function toWorkspaceOptions(
  organisations: AuthzOrganisation[],
  unnamedWorkspaceLabel: string
): WorkspaceOption[] {
  const hasMultipleOrganisations = organisations.length > 1;

  const options = organisations.flatMap((organisation) =>
    organisation.workspaces.map((workspace) => {
      const workspaceName =
        workspace.name ?? organisation.name ?? unnamedWorkspaceLabel;
      const label =
        hasMultipleOrganisations && organisation.name && workspace.name
          ? `${organisation.name} / ${workspace.name}`
          : workspaceName;

      return {
        value: workspace.platformWorkspaceId,
        label,
        imageUrl: getWorkspaceLogoUrl(workspace),
      };
    })
  );

  return options.sort((a, b) =>
    a.label.localeCompare(b.label, undefined, {
      sensitivity: "base",
      numeric: true,
    })
  );
}

export { FALLBACK_LOGO_URL, toWorkspaceOptions };
export type { WorkspaceOption };
